import React from 'react';
import _ from 'lodash';
import { FormControl, TextField, Typography } from '@mui/material';
import { DebounceInput } from 'react-debounce-input';
import { RequiredField } from '../others/RequiredField';
import { handleShowOn } from '../../services/functions';
import { InfoField } from './InfoField';
import { CssTextField } from '../others/CssTextField';

export const CharField = props => {
  const { field, type, formik, getFieldCallback } = props;

  return (
    <FormControl style={{ paddingBottom: 15, display: field.hide ? 'none' : handleShowOn(
      field.show_on, formik.values,
      getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none' }}
    fullWidth >
      <Typography variant="subtitle1" >
        <b>{field.label}</b>
        <RequiredField required={field.required} isEmpty={_.isEmpty(formik.values[field.name])} formikError={formik.touched[field.name] && Boolean(formik.errors[field.name])} />
      </Typography>
      <CssTextField
        // debounceTimeout={100}
        element={CssTextField}
        type={type}
        name={field.name}
        label={field.placeholder}
        value={formik.values[field.name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched[field.name] && Boolean(formik.errors[field.name])}
        helperText={formik.touched[field.name] && formik.errors[field.name]}
        variant="outlined"

      />
      {
        !_.isEmpty(field.infos)
          ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
          : null
      }
    </FormControl>
  );
};
